<umss-button
  label="Feedback"
  leftIconName="phosphorChatCircle"
  variant="Primary"
  size="Small"
  (pointerdown)="onPointerDown($event)"
  (onClick)="onActivate()"
/>
